import EnhancedSEO from '@/components/seo/EnhancedSEO';
import HeroSection from '@/components/about/HeroSection';
import WhySection from '@/components/about/WhySection';
import ActionSection from '@/components/about/ActionSection';
import OurStorySection from '@/components/about/OurStorySection';
import TeamSection from '@/components/about/TeamSection';
import ValuesSection from '@/components/about/ValuesSection';
import ClosingSection from '@/components/about/ClosingSection';
import BreadcrumbListSchema from '@/components/seo/BreadcrumbListSchema';

const About = () => {
  return (
    <>
      <EnhancedSEO 
        title="About SeniorThrive - Changing the Conversation About Aging"
        description="Learn about our mission to empower older adults to thrive at home. Discover our story, values, and commitment to independence with dignity."
        keywords="about senior care, aging in place, independent living, senior safety, family caregiving, SeniorThrive mission, senior wellness platform"
        canonical="https://seniorthrive.com/about"
        breadcrumbs={[
          { name: "Home", url: "https://seniorthrive.com/" },
          { name: "About", url: "https://seniorthrive.com/about" }
        ]}
        schema={{
          type: "Organization",
          name: "SeniorThrive",
          description: "Empowering older adults to thrive at home with comprehensive wellness and safety solutions",
          foundingDate: "2023",
          founder: "SeniorThrive Team"
        }}
      />
      <BreadcrumbListSchema
        breadcrumbs={[
          { name: 'Home', url: 'https://seniorthrive.com/' },
          { name: 'About', url: 'https://seniorthrive.com/about' },
        ]}
      />
      
      <HeroSection />
      <WhySection />
      <ActionSection />
      <OurStorySection />
      <TeamSection />
      <ValuesSection />
      <ClosingSection />
    </>
  );
};

export default About;